import React from "react";
import { Avatar, Box, styled, useMediaQuery } from "@mui/material";
import theme from "styles/theme/theme";

const Logo = styled(Avatar)(({ theme }) => ({
  width: 440,
  height: "auto",
  objectFit: "contain",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: 340,
  },
}));

function Cover() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        padding: "40px 0 0 0",
        marginBottom: 0,
        zIndex: 1,
        backgroundColor: "var(--color-brand-cream-primary)",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#aa9d89",
          width: "100%",
          height: { xs: 360, sm: 450 },
          borderRadius: { xs: 0, sm: "0 0 0 200px" },
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          width: { xs: "100%", sm: "85%" },
          height: { xs: 380, sm: 500, md: 600 },
          borderRadius: "60px",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: "url('/images/image-optimize/living.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          margin: "0 auto",
          position: "relative",
          zIndex: 3,
        }}
      >
        <Box>
          <Logo
            src={
              isMobile ? "/images/v2/logos/10.png" : "/images/v2/logos/9.png"
            }
            alt="Logo Re/max"
            variant="square"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Cover;
